import AxleCounterProvider from '../providers/AxleCounterProvider'

var AxleCounterService = function () {
  return {
    GetLogbookByRailobjectId: function (railobjectid, startFrom, nrOfRows) {
      return AxleCounterProvider.GetLogbookByRailobjectId(railobjectid, startFrom, nrOfRows)
    },
    GetZprStateByRailobjectId: function (railobjectid, startFrom, nrOfRows) {
      return AxleCounterProvider.GetZprStateByRailobjectId(railobjectid, startFrom, nrOfRows)
    },
    GetMeasurementByRailobjectid: function (railobjectid, startFrom, nrOfRows) {
      return AxleCounterProvider.GetMeasurementByRailobjectid(railobjectid, startFrom, nrOfRows)
    },
    GetAlarmSettingsByRailobjectid: function (railobjectid, startFrom, nrOfRows) {
      return AxleCounterProvider.GetAlarmSettingsByRailobjectid(railobjectid, startFrom, nrOfRows)
    }
  }
}

export default new AxleCounterService()



// WEBPACK FOOTER //
// ./src/services/AxleCounterService.js